export const POPUP_HEADING = "Is this the right shopping experience for you?";

export const SELECTED_COUNTRY_TEXT = `We've detected that you're browsing from`;

export const CONFIRM_COUNTRY_TEXT = "To ensure the best experience, please confirm your country";
